import { inject, Injectable } from '@angular/core';
import { FileInfo } from '../../../interfaces';
import { FileTypeService } from '../../../services/file-type.service';
import { FileUtilsService } from '../../../services/file-utils.service';
import { MediaType } from '../../../models/media-player-types';

@Injectable({ providedIn: 'root' })
export class MediaPlayerHelperService {
  private readonly fileTypeService: FileTypeService = inject(FileTypeService);
  private readonly fileUtilsService: FileUtilsService = inject(FileUtilsService);
  public getMediaType(item: FileInfo): string {
    if (this.fileTypeService.isImageFile(item)) {
      return MediaType.IMAGE;
    } else if (this.fileTypeService.isAudioFile(item)) {
      return MediaType.AUDIO;
    } else if (this.fileTypeService.isVideoFile(item)) {
      return MediaType.VIDEO;
    } else if (item.contentType == 'application/pdf') {
      return MediaType.PDF;
    } else if (this.fileTypeService.isOfficeDocWithoutPpt(item)) {
      return MediaType.OFFICEDOC;
    } else if (this.fileTypeService.isConvertibleImageFormat(item)) {
      return MediaType.CONVERTIBLEIMAGE;
    } else if (this.fileTypeService.isPowerPointFile(item)) {
      return MediaType.POWERPOINT;
    } else if (this.fileTypeService.isKeynoteFile(item)) {
      return MediaType.KEYNOTE;
    }

    return '';
  }

  public getVideoType(item: FileInfo | null): string | undefined {
    if (!item) return undefined;

    const { publicLink, name } = item;
    const extensions: string[] = [publicLink, name].filter((val: string | null | undefined): val is string => !!val);

    if (this.hasAnyExtension(extensions, ['mpeg', 'mp4', 'mkv', 'mov', 'avi'])) {
      return 'video/mp4';
    }
    if (this.hasAnyExtension(extensions, ['webm'])) {
      return 'video/webm';
    }
    if (this.hasAnyExtension(extensions, ['flv'])) {
      return 'video/x-flv';
    }

    return undefined;
  }

  /**
   * Check if any of the extensions match the given extension list
   */
  private hasAnyExtension(extensions: string[], targetExtensions: string[]): boolean {
    return extensions.some((ext: string) =>
      targetExtensions.some((targetExt: string) => this.fileUtilsService.isFileExtension(ext, targetExt))
    );
  }

  /**
   * Update viewport height CSS variable for mobile browsers
   */
  public updateViewportHeight(): void {
    const vh: number = document.body.clientHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
}
